import { useEffect, useId, useState } from 'react';
import { Link } from 'react-router-dom';
import './AboutSection.css';

const AboutSection = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const dialogTitleId = useId();

  useEffect(() => {
    if (!isVideoOpen) return;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') setIsVideoOpen(false);
    };

    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isVideoOpen]);

  return (
    <section className="basic-section alt">
      <div className="container">
        <div className="basic-grid">
          <div className="image-cover">
            <img
              sizes="(max-width: 3360px) 100vw, 3360px"
              srcSet="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893160063c4f0318aa87fa3_Scherm%C2%ADafbeelding%202025-08-06%20om%2010.44.19-p-500.webp 500w, https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893160063c4f0318aa87fa3_Scherm%C2%ADafbeelding%202025-08-06%20om%2010.44.19-p-800.webp 800w, https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893160063c4f0318aa87fa3_Scherm%C2%ADafbeelding%202025-08-06%20om%2010.44.19-p-1080.webp 1080w, https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893160063c4f0318aa87fa3_Scherm%C2%ADafbeelding%202025-08-06%20om%2010.44.19-p-1600.webp 1600w, https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893160063c4f0318aa87fa3_Scherm%C2%ADafbeelding%202025-08-06%20om%2010.44.19-p-2000.webp 2000w, https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893160063c4f0318aa87fa3_Scherm%C2%ADafbeelding%202025-08-06%20om%2010.44.19-p-2600.webp 2600w, https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893160063c4f0318aa87fa3_Scherm%C2%ADafbeelding%202025-08-06%20om%2010.44.19-p-3200.webp 3200w, https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893160063c4f0318aa87fa3_Scherm%C2%ADafbeelding%202025-08-06%20om%2010.44.19.webp 3360w"
              alt=""
              src="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893160063c4f0318aa87fa3_Scherm%C2%ADafbeelding%202025-08-06%20om%2010.44.19.webp"
              loading="eager"
              className="image-cover-bg"
            />
            <button
              type="button"
              className="about-video-trigger"
              aria-label="Video afspelen"
              aria-haspopup="dialog"
              onClick={() => setIsVideoOpen(true)}
            >
              <img
                src="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893647221110af7d3ab8082_play_circle_24dp_FFFFFF_FILL1_wght400_GRAD0_opsz24.svg"
                loading="lazy"
                alt=""
                className="image-10"
              />
            </button>
          </div>

          <div>
            <div className="sub-text">glas, glasbeslag en beglazingsmaterialen</div>
            <h2 className="h2">Specialist in glastoepassingen</h2>
            <p className="paragraph">
              Onze producten leveren wij aan glaszetters, schildersbedrijven, timmerfabrieken,
              gevelindustrie en andere glas gerelateerde bedrijven van klein tot groot. Deze professionele klanten
              kunnen bij ons terecht voor een compleet assortiment glas, glasbeslag, beglazingsmaterialen en ook
              totale ontzorging op het gebied van montage. Alle artikelen worden met ons eigen transport geleverd
              door heel Nederland en Vlaanderen!
            </p>
            <div className="button-block big">
              <Link to="/about" className="button w-button">
                Meer over Timmers B.V.
              </Link>
            </div>
          </div>
        </div>
      </div>

      {isVideoOpen && (
        <div
          className="about-video-overlay"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setIsVideoOpen(false);
          }}
        >
          <div
            className="about-video-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby={dialogTitleId}
          >
            <div className="about-video-header">
              <div id={dialogTitleId} className="about-video-title">
                Video
              </div>
              <button
                type="button"
                className="about-video-close"
                aria-label="Sluiten"
                onClick={() => setIsVideoOpen(false)}
              >
                ×
              </button>
            </div>

            <div className="about-video-frame">
              <iframe
                src="https://www.youtube.com/embed/kdiPdzpNX3k?autoplay=1"
                title="YouTube video"
                allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default AboutSection;
